export default {
	legacy: false,
	locale: 'zh',
	fallbackLocale: 'zh',
	messages: {
		zh: require('@/i18n/zh.json'),
		uyg: require('@/i18n/uyg.json'),
	},
};
